// src/pages/admin/LecteurEvaluationRichDemo.jsx
import React, { useState, useEffect } from 'react';
import { APP_CONFIG } from '../../../config/appConfig';
import EvaluationRich from '../../../components/communs/EvaluationRich';
import { Loader2, AlertCircle } from 'lucide-react';

export default function LecteurEvaluationRichDemo({
    evaluationId,
    token,
    onClose,
    initialEvaluationRich,
}) {
    const [loading, setLoading] = useState(!initialEvaluationRich);
    const [error, setError] = useState(null);
    const [evaluation, setEvaluation] = useState(initialEvaluationRich || null);

    useEffect(() => {
        if (evaluation) return;
        const fetchEvaluation = async () => {
            try {
                const response = await fetch(
                    `${APP_CONFIG.BASE_URL}/api/v1/admin/evaluations-rich/${evaluationId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Accept': 'application/json'
                        }
                    }
                );
                if (!response.ok) throw new Error(`Erreur HTTP ${response.status}`);
                const data = await response.json();
                setEvaluation(data);
            } catch (err) {
                console.error('[LecteurEvaluationRichDemo] Erreur:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        if (evaluationId && token) fetchEvaluation();
        else if (!evaluationId && !initialEvaluationRich) {
            setError("Aucun ID d'évaluation enrichie fourni");
            setLoading(false);
        }
    }, [evaluationId, token, initialEvaluationRich, evaluation]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center max-w-md px-4">
                    <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
                    <p className="text-sm text-gray-600">{error}</p>
                    <button onClick={onClose} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg">Fermer</button>
                </div>
            </div>
        );
    }

    if (!evaluation) return null;

    return (
        <EvaluationRich
            evaluation={evaluation}
            formationTitre={evaluation.titre || 'Évaluation enrichie'}
            moduleOrdre={1}
            totalModules={1}
            onClose={onClose}
            isOpen={true}
            onSubmit={() => {}}
            mode="demo"
            token={token}
        />
    );
}